// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__26Hu4","actions":"GroupTable_actions__1SclG","deleteModalFooter":"GroupTable_deleteModalFooter__5Di08"};